import type { OnsetAuditTrack } from './onset-audit-model.js';

// Generated by applying the frozen KK7 opening-boom model to all 362 KK11 outputs.
export const ONSET_AUDIT_TRACKS: readonly OnsetAuditTrack[] = [
  {
    id: '24aaccc2-3d1b-48d9-a351-15790712f17f',
    title: 'Hexed Velocity',
    rank: 1,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_449677bb-6e0b-46d2-8d2e-b4b4752ba8f4_0.ogg',
    impactScore: 0.9684818160449561,
  },
  {
    id: 'f2d56a87-57b7-4ae1-a081-99a220fc930e',
    title: 'Club Horizon',
    rank: 2,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ff81bca5-cdcd-448c-85e7-a73be4658e09_1.ogg',
    impactScore: 0.9574661893531773,
  },
  {
    id: '12500a62-c598-4b64-b3c7-ebe194fbc37e',
    title: 'Club Spectrum',
    rank: 3,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b84472b0-724d-4c3a-836e-54e364f62bad_0.ogg',
    impactScore: 0.9382629116421589,
  },
  {
    id: '0da7e557-e497-49b1-a215-5e93d7cbb23b',
    title: 'Clubbed Hearts',
    rank: 4,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_35e76db7-598f-4d46-89e8-4905c74fb610_0.ogg',
    impactScore: 0.937657113499106,
  },
  {
    id: 'b21f24fd-e6f8-47d0-9b96-8704e9df6ebb',
    title: 'Clubs in the Static',
    rank: 5,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_342b3d9a-42e4-4d98-b333-e9fde0cc959d_0.ogg',
    impactScore: 0.937103149724515,
  },
  {
    id: 'ec075ce0-e0ad-41c6-8c7e-53e3e7ba6c79',
    title: 'Hexed Velocity',
    rank: 6,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d59ab7ef-ccda-4e91-81d7-c7a3923da758_0.ogg',
    impactScore: 0.9360968256658645,
  },
  {
    id: '3d97ac36-68a8-4889-bff3-5eaa03bd0d6b',
    title: 'Synthwave Rush',
    rank: 7,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c53f9dfe-cfd4-44ef-a6ef-c10468b55440_1.ogg',
    impactScore: 0.9359571607775988,
  },
  {
    id: 'af79090a-9320-4805-8941-cf38b2a5823a',
    title: 'Hexed Frequency',
    rank: 8,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0b9d2945-c576-44fa-9eed-046c2db07d3d_0.ogg',
    impactScore: 0.9299131080199677,
  },
  {
    id: '3624f238-f156-4a6c-856d-dd445d8423ba',
    title: 'Velocity Dreams',
    rank: 9,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_57d342f8-c8f4-4696-984f-442849c77f98_1.ogg',
    impactScore: 0.919372883778003,
  },
  {
    id: '005b5066-685e-4982-bc31-134184680489',
    title: 'Hyperdrive Hearts',
    rank: 10,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_19e668f8-f8a2-4019-a7f3-efed38146fae_1.ogg',
    impactScore: 0.9154877015150947,
  },
  {
    id: '4f5e7512-2574-4195-8c15-47e100c3e4b9',
    title: 'Euro Trance Protocol',
    rank: 11,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0e7f6843-0923-41e9-8a1d-88ce55a75d66_1.ogg',
    impactScore: 0.9122925406989746,
  },
  {
    id: 'ca9c6904-2759-4735-be41-556c928b04e6',
    title: 'Club Current',
    rank: 12,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1fd31f4c-a926-40a9-8670-98841d35b577_0.ogg',
    impactScore: 0.9108907598325898,
  },
  {
    id: 'd352bff8-d78b-45ed-828c-39b7e8d6bc92',
    title: 'Club Lights Collide',
    rank: 13,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_cf196220-0f42-48d5-a616-ed94081901a6_0.ogg',
    impactScore: 0.9097332118148233,
  },
  {
    id: '37b753ad-7048-464a-ad30-fc1455278bf2',
    title: 'Hexd Horizon',
    rank: 14,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_cfc589ab-3898-4a58-8faa-0a83d831afb9_0.ogg',
    impactScore: 0.9089890383135021,
  },
  {
    id: '18b114b7-32db-4c8c-a580-bae649e1702f',
    title: 'Neon Grid Rush',
    rank: 15,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5e5e35b1-9c60-4786-9b02-c054577a0a1c_0.ogg',
    impactScore: 0.908266334767761,
  },
  {
    id: 'add4d29c-46f8-408f-85e8-3fa0a42100f6',
    title: 'Midnight Voltage',
    rank: 16,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0b60cd08-ea64-46dc-8ded-cfdcbb966ab8_0.ogg',
    impactScore: 0.9069540993446813,
  },
  {
    id: 'cf1b9ca1-d4ed-442e-afab-b25c3e7c1c7b',
    title: 'Overdrive Dream',
    rank: 17,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_cb9e992d-1435-4801-8e24-bc07dd414e55_1.ogg',
    impactScore: 0.9009251500266203,
  },
  {
    id: '089fb626-6285-40f0-9859-3dfd06c7807d',
    title: 'Hexed Velocity',
    rank: 18,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e64b0eba-5f0f-46c2-9726-e95c227e5067_1.ogg',
    impactScore: 0.898074365165236,
  },
  {
    id: '46d1cdc1-3c68-4d00-b9c1-e8f8d799030c',
    title: 'Bassline Euphoria',
    rank: 19,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_69d5bb87-6545-4791-bc99-bcc0fc549eca_0.ogg',
    impactScore: 0.8970362326817561,
  },
  {
    id: '2db772ab-61bd-4b70-9322-dca58ecc6ea9',
    title: 'Velocity Hearts',
    rank: 20,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d31a495c-0ea8-472c-a5c8-c2bca0ab547f_0.ogg',
    impactScore: 0.8969202377938945,
  },
  {
    id: 'd5c5ddc1-868d-4fcb-b960-97463f7d72a4',
    title: 'Velvet Frequency',
    rank: 21,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a5830b69-fcf5-4c75-b44a-939bcb84e66e_1.ogg',
    impactScore: 0.8956417472642049,
  },
  {
    id: '1527c150-1d42-4690-9aef-6258ad82dc93',
    title: 'Club Frequency',
    rank: 22,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8dd360c0-2f6e-428b-a1f4-c9abf74fa08c_1.ogg',
    impactScore: 0.8934468004261827,
  },
  {
    id: '22e6558a-9b2b-41f4-a2b3-177039e189aa',
    title: 'Jersey Skyline Rush',
    rank: 23,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_acaf458b-7595-406f-9c8f-e313b6fe7547_1.ogg',
    impactScore: 0.8889037732332624,
  },
  {
    id: 'b64f90b3-01a2-4285-af2b-39f7764744a1',
    title: 'Velocity Hearts',
    rank: 24,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f557bd12-06c0-4911-af12-1db080580b68_0.ogg',
    impactScore: 0.8872091429234529,
  },
  {
    id: '9c99e44f-e499-4902-8f4d-2dc6e8bcdcc9',
    title: 'Resonance Protocol',
    rank: 25,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1fd31f4c-a926-40a9-8670-98841d35b577_1.ogg',
    impactScore: 0.8835164002507507,
  },
  {
    id: '248496c0-ead6-419a-a708-c8699025ef93',
    title: 'Club Horizon',
    rank: 26,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d59ab7ef-ccda-4e91-81d7-c7a3923da758_1.ogg',
    impactScore: 0.8819289787689745,
  },
  {
    id: '3fe670e7-db42-413d-af20-029984b5b77a',
    title: 'Static Love',
    rank: 27,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_995b799f-02fe-4a87-b9b4-749ed29d4222_1.ogg',
    impactScore: 0.8813165353408954,
  },
  {
    id: 'b4ec7025-b950-4400-8069-64bbb3567f1d',
    title: 'Velocity Dreams',
    rank: 28,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_57749849-a269-4077-b7b6-846d6011ec39_1.ogg',
    impactScore: 0.8811333917612222,
  },
  {
    id: '5877c3b6-979a-46c5-ac21-e8d7892313ab',
    title: 'Hexed Heartbeat',
    rank: 29,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ee3d3037-ac27-417d-aeb3-9ea29a6a8791_1.ogg',
    impactScore: 0.8810398487386261,
  },
  {
    id: 'c81ef5ec-d4d6-4dfd-addf-f3e882174084',
    title: 'Hexed Velocity',
    rank: 30,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9f9808fc-a6db-447e-a81b-cd8f03c867ee_1.ogg',
    impactScore: 0.8795604515237079,
  },
  {
    id: 'ad25bf77-8a45-4ef2-83b9-0e9bb021e7f1',
    title: 'Midnight Bounce',
    rank: 31,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f1e20b18-f164-42bd-bc72-9f730fbc4ef0_1.ogg',
    impactScore: 0.8790409871889988,
  },
  {
    id: 'edaf76ad-33f4-4229-a48a-b1aeec30d4ee',
    title: 'Club Circuit',
    rank: 32,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6eed580a-cc4b-4359-b9b4-5810cb513cf8_0.ogg',
    impactScore: 0.8777658623001652,
  },
  {
    id: 'b32bc93c-e467-4791-b644-add5f901f718',
    title: 'Club Voltage',
    rank: 33,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ac5d598f-1737-410e-b53f-821f80a523b5_0.ogg',
    impactScore: 0.8731171029157154,
  },
  {
    id: '25b34b25-8bac-4244-a9ce-ee000cde7dac',
    title: 'Underground Velocity',
    rank: 34,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c667973d-709e-44f3-82df-164743f6f786_0.ogg',
    impactScore: 0.8720933313975227,
  },
  {
    id: 'dd87e29b-28b1-41a7-8b61-93870e2bbeb1',
    title: 'Club Vertigo',
    rank: 35,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_438a8a8e-d21c-489d-9db2-6599da405080_0.ogg',
    impactScore: 0.8720134127450987,
  },
  {
    id: '4c09b5db-24c8-427d-a4a6-dda00fc6dabc',
    title: 'Afterburn',
    rank: 36,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_99e0b623-d3a9-4892-b34f-982f5bd312c9_1.ogg',
    impactScore: 0.8713263394375038,
  },
  {
    id: 'f3c68615-8d93-4847-a212-1636599fe66a',
    title: 'Pulse Collide',
    rank: 37,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d47d912f-677c-42d8-b166-fe076020de2e_1.ogg',
    impactScore: 0.870996845608355,
  },
  {
    id: '503d9be2-9291-43f7-b4f9-0a051d509ac9',
    title: 'Velocity Dreams',
    rank: 38,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5f04ca0c-a867-4941-84ca-4916246dd43b_1.ogg',
    impactScore: 0.8700103161535788,
  },
  {
    id: 'c77e2cf1-a17d-402b-b2cf-0f9f480a45f4',
    title: 'Club Static',
    rank: 39,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9b2c033d-ed77-4b36-a7b1-8a35bbd562d8_1.ogg',
    impactScore: 0.8694996298021562,
  },
  {
    id: '9b7f30cd-b6fc-4c80-8f37-7f690968632e',
    title: 'Club Circuit',
    rank: 40,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2d71e9fe-a46f-42ea-863b-adadff570257_0.ogg',
    impactScore: 0.8685770362222832,
  },
  {
    id: 'f7220e39-ba5c-455d-89ce-3491fdb041bd',
    title: 'Six Feet of Sound',
    rank: 41,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_666b8ec1-6de4-4666-91a9-5ca1533213db_0.ogg',
    impactScore: 0.8661172652438215,
  },
  {
    id: '0000d4fb-8f4b-4aa6-ae35-b132e2e22724',
    title: 'Midnight Dashboard',
    rank: 42,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2a13638c-4b95-49d0-a901-3b42bfd393ef_1.ogg',
    impactScore: 0.8648394127829248,
  },
  {
    id: '04290d4e-1289-46c0-b7d2-702d5b8bde33',
    title: 'Hexed Horizon',
    rank: 43,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a98931aa-fa6e-47ad-b9e5-4260f5918fe3_1.ogg',
    impactScore: 0.8645896494970486,
  },
  {
    id: 'b63ce6e8-3fa7-4622-adc2-89a234565b95',
    title: 'Club Grid Collapse',
    rank: 44,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6236decc-fb9b-4dd5-a4aa-35a1b23c44e7_0.ogg',
    impactScore: 0.864171847544196,
  },
  {
    id: '4a98b55f-4fd9-4fef-88a7-b1df7db3e762',
    title: 'Pulse Drive',
    rank: 45,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_666b8ec1-6de4-4666-91a9-5ca1533213db_1.ogg',
    impactScore: 0.8641443094291151,
  },
  {
    id: '85b25f17-c2d3-4695-9b74-bc4f64bc691d',
    title: 'Rave Velocity',
    rank: 46,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b53d1127-186b-4d01-b727-70dd2449d2a2_1.ogg',
    impactScore: 0.862755284351723,
  },
  {
    id: '3174a60c-04c0-4619-9997-5696034ed310',
    title: 'Hexed Rush',
    rank: 47,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7c7bfeeb-3a36-44c5-a1a4-3dc7dc4c905d_1.ogg',
    impactScore: 0.8546604982837965,
  },
  {
    id: 'b0b7672e-7aeb-4ceb-bda8-9e182a0ac21c',
    title: 'Hex Drive',
    rank: 48,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c24d0266-8e1f-443d-916a-c52af236084c_0.ogg',
    impactScore: 0.8542612577532123,
  },
  {
    id: '70360bac-12bb-4e54-b574-144967ad54ff',
    title: 'Hexed Hearts',
    rank: 49,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9c8dc7d5-d36b-4723-b555-564815764bfa_1.ogg',
    impactScore: 0.8511805637135065,
  },
  {
    id: '182b487d-cb98-42b5-95ca-761de7e8e946',
    title: 'Hexed Pulse',
    rank: 50,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2d71e9fe-a46f-42ea-863b-adadff570257_1.ogg',
    impactScore: 0.8487721626649143,
  },
  {
    id: '064e46da-362b-4aa1-ad2e-bb8af455c4c3',
    title: 'Hex Horizon',
    rank: 51,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f33892ee-406a-4d4c-87ca-ee71bf4e313f_1.ogg',
    impactScore: 0.8482325128831188,
  },
  {
    id: '4151dc9f-6873-48fe-a628-7abac281d575',
    title: 'Jersey Voltage',
    rank: 52,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_300119a4-2a4f-425d-a5b8-78e7e78020b2_0.ogg',
    impactScore: 0.8469297999549477,
  },
  {
    id: '137447bc-1e39-48dc-b6fa-31c0ae29db06',
    title: 'Velocity Bloom',
    rank: 53,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6a9066b9-5f8e-4ad6-9771-4140b3ddd735_1.ogg',
    impactScore: 0.8440972493897344,
  },
  {
    id: 'a19af6eb-d526-4f52-b9ef-1a650791f6c5',
    title: 'Glitch in the Club',
    rank: 54,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_55204fe3-565d-412f-b557-54fdb94ff587_0.ogg',
    impactScore: 0.8422337254730026,
  },
  {
    id: '1dfed102-f1a1-4f19-bc91-ec3ab0158479',
    title: 'Low-Key Elevated',
    rank: 55,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3e605cfd-714e-4b58-9694-90db75876096_0.ogg',
    impactScore: 0.836186579250322,
  },
  {
    id: '2d894d83-33c7-4ee4-a461-54a394aa2fb4',
    title: 'Afterglow Through the Static',
    rank: 56,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9cc4817a-5466-4ce5-b788-348b6b3d4e68_0.ogg',
    impactScore: 0.8336244012396413,
  },
  {
    id: '5597f675-7fb7-4c53-a816-00d1f0483131',
    title: 'Hexed Heartbeat',
    rank: 57,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6a9066b9-5f8e-4ad6-9771-4140b3ddd735_0.ogg',
    impactScore: 0.8305309295613443,
  },
  {
    id: '4e2468a7-c538-47ac-b471-6cf30df29917',
    title: 'Shattered Frequencies',
    rank: 58,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a8fc1d59-28e5-4943-b029-c3da2d16d181_0.ogg',
    impactScore: 0.8290771816177183,
  },
  {
    id: '02ead6a6-3d71-4eef-8895-8439e822c2ca',
    title: 'Sixteen Stations',
    rank: 59,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b1acb27e-f1ac-4a2d-981d-34ef9b338629_1.ogg',
    impactScore: 0.8253015266975122,
  },
  {
    id: '41556d41-7c95-48b4-bae0-63f9a1b075ab',
    title: 'Midnight Rush',
    rank: 60,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9095b8bf-83dc-4a37-a7d5-717b8270ad11_0.ogg',
    impactScore: 0.8226578695567189,
  },
  {
    id: 'eb67055a-736d-4375-b42b-41c0eba4f6b3',
    title: 'Hexd in the Club',
    rank: 61,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_94af04ed-1cd6-462c-a6f6-3cf104911676_0.ogg',
    impactScore: 0.8220538467219232,
  },
  {
    id: '460d7321-ddcf-4a58-a2b7-7fb59c268a3a',
    title: 'Hexd Voltage',
    rank: 62,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f5d8e8e5-4d00-44c7-8685-3a01659184b7_0.ogg',
    impactScore: 0.8101607663178474,
  },
  {
    id: 'c9bc4003-0bb9-4400-89d5-62e1ab9c04a0',
    title: 'Trinity Pulse',
    rank: 63,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_678069e3-228e-4cb9-883b-8b29ebd1cb10_0.ogg',
    impactScore: 0.8051706409657686,
  },
  {
    id: '978e3db0-339e-41af-bf49-e4dc808b4b82',
    title: 'Berlin Hex',
    rank: 64,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_438a8a8e-d21c-489d-9db2-6599da405080_1.ogg',
    impactScore: 0.8036592250964854,
  },
  {
    id: '0eb264e6-123e-4bd0-8cc3-dab32a07df8e',
    title: 'Club Voltage',
    rank: 65,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_84eae012-df92-413d-9d04-840c4ba70157_0.ogg',
    impactScore: 0.8034565030589857,
  },
  {
    id: '62f86ace-53bc-4320-b22c-a3f7a01483d5',
    title: 'Hexd Up Love',
    rank: 66,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bf6ffe39-e934-4bba-bb8f-b79b60b8109e_1.ogg',
    impactScore: 0.8033249676963862,
  },
  {
    id: '0a7f6b93-082a-41aa-946c-a4d990d69850',
    title: 'Tidal Surge',
    rank: 67,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_678e5df5-f197-4f14-92a7-bca755543734_1.ogg',
    impactScore: 0.8027728364021409,
  },
  {
    id: 'd0718c88-3c17-4221-995f-390137edfdc7',
    title: 'Static Hearts',
    rank: 68,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bf47c6d2-ecfd-4de0-b1db-48d83359a2c5_0.ogg',
    impactScore: 0.7996874843813074,
  },
  {
    id: '07ec13ef-8f1e-4322-8ae0-9d09bb4ce74f',
    title: 'Velvet Circuit',
    rank: 69,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e56db16a-6a4e-4017-b502-cc1b9cf28fc7_1.ogg',
    impactScore: 0.7935285533808283,
  },
  {
    id: 'f0e8481e-9c95-4d12-9b4f-c30eccfe32c5',
    title: 'Underground Pulse',
    rank: 70,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b085a140-1285-4113-90db-f2dd069094aa_0.ogg',
    impactScore: 0.7913916787701696,
  },
  {
    id: '8de507d6-c903-47db-9967-753b0acb73a1',
    title: 'Jersey Mirage',
    rank: 71,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a9577f2c-05ea-4249-80d4-756aad1fb20d_1.ogg',
    impactScore: 0.7913246787838765,
  },
  {
    id: 'e1f3066a-0040-4acb-af3d-6a1c296cd775',
    title: 'Velocity Bloom',
    rank: 72,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d5d8b462-1bf3-41bf-8372-f758f9a67b9b_1.ogg',
    impactScore: 0.7902255676644688,
  },
  {
    id: '36b93f28-63ef-46ea-b1c3-970c010842dd',
    title: 'Cut The Skyline',
    rank: 73,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_77816e27-7c06-49bf-8c84-6d1f2d80a7a9_1.ogg',
    impactScore: 0.7897414336076833,
  },
  {
    id: 'b62deb4a-7dde-41be-a551-c9bbbeea533f',
    title: 'Club of Tomorrow',
    rank: 74,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0b9d2945-c576-44fa-9eed-046c2db07d3d_1.ogg',
    impactScore: 0.788662775220541,
  },
  {
    id: '17afb139-1a90-4c4c-8834-0d2980032966',
    title: 'Hyperglide',
    rank: 75,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b1acb27e-f1ac-4a2d-981d-34ef9b338629_0.ogg',
    impactScore: 0.7877868291158829,
  },
  {
    id: 'c138b34f-bb51-4753-8875-70d930eb7b60',
    title: 'Club Static',
    rank: 76,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0b60cd08-ea64-46dc-8ded-cfdcbb966ab8_1.ogg',
    impactScore: 0.7836963554659655,
  },
  {
    id: 'f63ca867-6a51-4a02-bdb3-933234e82e78',
    title: 'Velocity Nights',
    rank: 77,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bf6ffe39-e934-4bba-bb8f-b79b60b8109e_0.ogg',
    impactScore: 0.7818732792030574,
  },
  {
    id: 'eac450e5-a18f-4d58-90a7-2af441e1e5b5',
    title: 'Hexd Dreams',
    rank: 78,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0cf983a4-bda1-4a72-b004-fbad5c537f1f_1.ogg',
    impactScore: 0.7801792129473453,
  },
  {
    id: 'f8b60d0a-26e0-4736-8d5a-c4b28b682c70',
    title: 'Bassline Mirage',
    rank: 79,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bf47c6d2-ecfd-4de0-b1db-48d83359a2c5_1.ogg',
    impactScore: 0.7795880317175023,
  },
  {
    id: 'a98a4a27-4017-43c1-9ce0-1e91ee4a71ff',
    title: 'Hexed Velocity',
    rank: 80,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_31a38d6c-7673-4ad9-ab07-2e10ec75a76c_1.ogg',
    impactScore: 0.7734902734781299,
  },
  {
    id: '083da868-8138-430e-b9c8-9735fdb544ca',
    title: 'Berlin Static',
    rank: 81,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0ec81db5-df9b-43d6-b60d-008905e32af8_1.ogg',
    impactScore: 0.773374337587102,
  },
  {
    id: '7ad9b0e2-950d-4d0e-a4bd-36048a27491f',
    title: 'Vertigo Circuit',
    rank: 82,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e0de3353-4f8c-459c-977a-be59011dbc25_0.ogg',
    impactScore: 0.7733527086754097,
  },
  {
    id: '1e948a91-e792-4663-8b2e-98cd16b766f9',
    title: 'Glitch Paradise',
    rank: 83,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d4ddb84b-76f6-48fb-bcbb-9b0e6171fcd5_1.ogg',
    impactScore: 0.7732307873234859,
  },
  {
    id: 'b6b160ca-0c8b-4c9f-844d-fc427f5cd150',
    title: 'Hexd Velocity',
    rank: 84,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7cce1908-0457-4495-bf44-6e43d047a2ab_1.ogg',
    impactScore: 0.7710256413470823,
  },
  {
    id: '500338bb-f287-42db-b5b7-c2097d6987a3',
    title: 'Pulse Overdrive',
    rank: 85,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f4900a5b-a69e-4102-9444-8a9b1f4b391a_1.ogg',
    impactScore: 0.7641931665602301,
  },
  {
    id: '61f2ec9c-7a8f-4c1d-9f17-59162f8c7833',
    title: 'Sixth Side Repeat',
    rank: 86,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8d03c6d0-5fe4-461b-8941-b2badcdeed13_0.ogg',
    impactScore: 0.7621404954108352,
  },
  {
    id: '045ad9be-43aa-4a2c-a88f-2ec8b40974de',
    title: 'Sixth Gear Symphony',
    rank: 87,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_60c8af4c-55ee-46c1-baac-1e7766751b14_0.ogg',
    impactScore: 0.7479923718252951,
  },
  {
    id: 'e8d89a9f-bdb8-430a-9a42-578a4176bf1f',
    title: 'Hyperdrive Hearts',
    rank: 88,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2b7434ed-ed9e-47d9-88f3-b2a412dfba69_0.ogg',
    impactScore: 0.7476846293446592,
  },
  {
    id: 'ec0a6ccf-f4f3-48e5-8994-c092fad486bc',
    title: 'Hexed in the Club',
    rank: 89,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b7035747-cbd2-4a8e-972e-078dc2772d1e_0.ogg',
    impactScore: 0.7450512028080406,
  },
  {
    id: '937c6968-a6d3-42a0-9509-f47916dfa4a4',
    title: 'Glitchlight Rush',
    rank: 90,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_183109f3-48c5-4dcc-a7c9-b23db892bc3d_1.ogg',
    impactScore: 0.7416393343930233,
  },
  {
    id: '737848e8-d553-44cc-b52a-dfb74c07f9c3',
    title: 'Pulse Deviation',
    rank: 91,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6b3cecbc-92e5-4c3c-9a72-90a001a1d33f_0.ogg',
    impactScore: 0.7407560685964251,
  },
  {
    id: '0cacac1e-cf6b-4759-b0da-e8759c7b5f7e',
    title: 'Jersey Circuit',
    rank: 92,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5a371964-bc3d-41ec-b4bc-23fde83f287f_1.ogg',
    impactScore: 0.7330197022291428,
  },
  {
    id: 'd767c212-4db0-4ad2-81e5-96179d30889c',
    title: 'Midnight Overdrive',
    rank: 93,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bb49e5f5-d3e9-4598-92c5-f4cb9dbb3457_0.ogg',
    impactScore: 0.7328221379659149,
  },
  {
    id: 'c7f28da4-790e-4a8b-aeb8-d8e3681e32b0',
    title: 'Clubbed Heartbeat',
    rank: 94,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_63cfe8f6-4f05-420a-91da-355c497ea921_0.ogg',
    impactScore: 0.7305532421090616,
  },
  {
    id: 'c70a8209-dbf8-4037-88ab-9d4908359d69',
    title: 'Club Circuit Breaker',
    rank: 95,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0e7f6843-0923-41e9-8a1d-88ce55a75d66_0.ogg',
    impactScore: 0.7235482547581441,
  },
  {
    id: '99088dac-7c98-4e4a-bdd5-f284fa820a17',
    title: 'Club Static',
    rank: 96,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_77ecfff0-a312-4c32-be9c-87dec642111d_0.ogg',
    impactScore: 0.7228454691710111,
  },
  {
    id: '99fb7656-f58c-48d5-beb6-ff5891546eef',
    title: 'Pulse in the Grid',
    rank: 97,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b6e965b9-ecf1-4b14-ae8c-51859b45ccad_1.ogg',
    impactScore: 0.7210057707934462,
  },
  {
    id: '578d2abb-9f28-4275-8a26-7d945b6f2e5a',
    title: 'Club Anomaly',
    rank: 98,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_28c3d6e3-328d-45c3-8cba-43525a4f8fca_1.ogg',
    impactScore: 0.7147879221811584,
  },
  {
    id: 'e8b413b1-32e7-4529-8559-1ac06be4662b',
    title: 'Club Hexed',
    rank: 99,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_75d45218-63f9-46e9-8f4b-3be1b3ad14e3_0.ogg',
    impactScore: 0.7140100150590811,
  },
  {
    id: '3a7ee208-2c22-4cec-9d64-d97e3eee487f',
    title: 'Electric Afterglow',
    rank: 100,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ec857670-d303-4de5-8c20-b6b9ceadf595_1.ogg',
    impactScore: 0.7135012402792413,
  },
  {
    id: 'c7d55995-0374-425b-b6b3-e104eba0078c',
    title: 'Voltage Hearts',
    rank: 101,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d7a76ddf-ad85-4500-8f7c-6740c66fd1a4_1.ogg',
    impactScore: 0.7134188235692631,
  },
  {
    id: '79658eb1-3df6-48fb-a792-a06dae396aa4',
    title: 'Bassline Circuit',
    rank: 102,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bb49e5f5-d3e9-4598-92c5-f4cb9dbb3457_1.ogg',
    impactScore: 0.7122749709608724,
  },
  {
    id: 'a37c7d80-826f-4268-a496-af6e33e63624',
    title: 'Hexed Pulse',
    rank: 103,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d07ec41e-4f64-4aac-b277-89b8e6a85815_0.ogg',
    impactScore: 0.7116139392017867,
  },
  {
    id: '0ed55cd0-346a-4790-8a45-f0a793b42693',
    title: 'Hex Hearts',
    rank: 104,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c27f91a9-127f-4629-8d43-1999598416f7_1.ogg',
    impactScore: 0.7077710719831427,
  },
  {
    id: '17698a09-f9c1-4be9-a806-3e31088100e0',
    title: 'Hexed Hearts',
    rank: 105,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f4ba621b-ab37-4290-85a1-97b979663b0d_0.ogg',
    impactScore: 0.7039608496343348,
  },
  {
    id: '0b54d1e5-9846-4305-ba3d-273007ba99d1',
    title: 'Clubbed in the Static',
    rank: 106,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4e04baed-c322-48ae-8251-7c20136014a6_1.ogg',
    impactScore: 0.7018782837317256,
  },
  {
    id: 'fdaa9bdf-718c-4f8d-bb72-a7b0b77e5856',
    title: 'Midnight Circuit',
    rank: 107,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8d7c447b-4d4b-4770-ba76-741033d2ff07_1.ogg',
    impactScore: 0.7017257719837702,
  },
  {
    id: '8af436a4-f8ae-42a6-9de8-cc3246b0e063',
    title: 'Jersey Sparks',
    rank: 108,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b07f0a21-48db-4e53-8bec-4442033d38da_1.ogg',
    impactScore: 0.7008437876933172,
  },
  {
    id: 'ea94e816-d0e2-4f1f-a62b-afab8e0e7461',
    title: 'Club Surge',
    rank: 109,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ca63df49-2a05-4c55-9efa-d5ab95f1158f_1.ogg',
    impactScore: 0.7001508050706892,
  },
  {
    id: '2a4c1878-4158-4637-a49c-51f19502ea8d',
    title: 'Midnight Rave Protocol',
    rank: 110,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d31a495c-0ea8-472c-a5c8-c2bca0ab547f_1.ogg',
    impactScore: 0.7000375645409556,
  },
  {
    id: '96efd371-aede-4dec-b204-ab896eea6f08',
    title: 'Midnight Autobahn',
    rank: 111,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_94d4d1a1-f95d-47d6-841f-9c342f743ed4_0.ogg',
    impactScore: 0.6997603604674885,
  },
  {
    id: 'ab184150-d770-4372-9090-1e10ed87ed2e',
    title: 'Club Spectrum',
    rank: 112,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3f22993d-b7af-433b-8479-228d8b2736d0_0.ogg',
    impactScore: 0.6994857734853591,
  },
  {
    id: '5d95d840-a7f3-468b-86b3-13317cc0eab9',
    title: 'Berlin Bounce',
    rank: 113,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_aa14cbaf-8ffe-4119-bfbb-98fb21ead171_1.ogg',
    impactScore: 0.6964485680951271,
  },
  {
    id: 'e3cf4847-47ca-48dc-8527-4b1063cbcfdd',
    title: 'Rush The Static',
    rank: 114,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a5830b69-fcf5-4c75-b44a-939bcb84e66e_0.ogg',
    impactScore: 0.6954123485099201,
  },
  {
    id: '39c78b79-0419-4570-8431-384da4ce006b',
    title: 'Midnight Club Velocity',
    rank: 115,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc8dca5b-d61f-475c-ab83-e41975ac8f1d_1.ogg',
    impactScore: 0.6954058337132898,
  },
  {
    id: '2bbc125b-935d-423e-9b7c-d791f7b5d0bc',
    title: 'Jersey Skylines',
    rank: 116,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_94af04ed-1cd6-462c-a6f6-3cf104911676_1.ogg',
    impactScore: 0.6889831412629274,
  },
  {
    id: '7a303069-cf93-47ae-b946-4c371ea8928c',
    title: 'Parallel Rush',
    rank: 117,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3c990615-6cc5-453f-aeb4-8a64b2be3c2c_0.ogg',
    impactScore: 0.6810523332341408,
  },
  {
    id: '1738c54f-8699-448b-99bc-b0ede768c4c4',
    title: 'Velocity Hex',
    rank: 118,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_678069e3-228e-4cb9-883b-8b29ebd1cb10_1.ogg',
    impactScore: 0.6736905730325098,
  },
  {
    id: '691a65e8-7bb6-44f3-bc24-bd64fdd8ba4b',
    title: 'Club Velocity',
    rank: 119,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f33892ee-406a-4d4c-87ca-ee71bf4e313f_0.ogg',
    impactScore: 0.6638919321550728,
  },
  {
    id: '24a864d7-513d-4bf2-b201-4ba1ee8d27a7',
    title: 'Hex Drive',
    rank: 120,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_35e76db7-598f-4d46-89e8-4905c74fb610_1.ogg',
    impactScore: 0.66256670109744,
  },
  {
    id: 'b8056137-83ee-480d-a249-bbfea838e5ad',
    title: 'Shattered Frequency',
    rank: 121,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_881efd40-abff-459c-a2ef-5aa4764d939b_1.ogg',
    impactScore: 0.6585850493303794,
  },
  {
    id: '63a1283e-5436-4165-9f55-6cdb8312c0b9',
    title: 'Bounce & Pulse',
    rank: 122,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5f6cb465-e530-4a92-a9d8-23d68417db49_1.ogg',
    impactScore: 0.6581112487241659,
  },
  {
    id: '99f73a4f-b193-4930-bbc0-b499bccb9e38',
    title: 'Club Hexed',
    rank: 123,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9fe9c573-90ad-42b3-a499-d2ccb82c95b3_0.ogg',
    impactScore: 0.6576404116029783,
  },
  {
    id: '2640dfc2-43c1-46fd-ba7d-acdc6ffc7b7e',
    title: 'Club Static',
    rank: 124,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2d36610c-689c-43eb-8ecc-e59adfb7190b_1.ogg',
    impactScore: 0.6570510372005691,
  },
  {
    id: 'cc9fbc54-0723-4869-a140-846f6b3957c6',
    title: 'Club Static',
    rank: 125,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a8fc1d59-28e5-4943-b029-c3da2d16d181_1.ogg',
    impactScore: 0.6558932495067237,
  },
  {
    id: '5f096da6-cf97-4c05-b14e-dd145cce8ad5',
    title: 'Club Static',
    rank: 126,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dcffc873-2de5-45f5-84f7-b157107db2c0_1.ogg',
    impactScore: 0.649144229163854,
  },
  {
    id: 'b55f0e2e-e2a1-402c-83e6-2de0a3a4d1af',
    title: 'Hexed Frequency',
    rank: 127,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2a13638c-4b95-49d0-a901-3b42bfd393ef_0.ogg',
    impactScore: 0.6487213929709361,
  },
  {
    id: '0bf13c8b-b465-4a23-936b-aadc1ad6d959',
    title: 'Hex Drive',
    rank: 128,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_dcffc873-2de5-45f5-84f7-b157107db2c0_0.ogg',
    impactScore: 0.6480419031355221,
  },
  {
    id: 'bea576d7-d091-4a44-9a35-84c64df98218',
    title: 'Club Avalanche',
    rank: 129,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ccbc57fe-01f8-47fa-8a39-c8c68e7f1bab_0.ogg',
    impactScore: 0.6464555284933354,
  },
  {
    id: '454f083f-21cc-4263-96f1-3da73a93f696',
    title: 'Glitch in the Club Lights',
    rank: 130,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_631793d6-8548-4247-b568-944215afc8ea_0.ogg',
    impactScore: 0.6458180023982073,
  },
  {
    id: 'd3d54fe0-d338-4ad4-91f9-51d8770fecab',
    title: 'Six Feet Overdrive',
    rank: 131,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_444fb966-be3e-489a-aee7-81c3250f6fcf_0.ogg',
    impactScore: 0.6424379456921899,
  },
  {
    id: 'c4e34219-6305-479d-b6f7-96cbe440e076',
    title: 'Hexed Velocity',
    rank: 132,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6b3cecbc-92e5-4c3c-9a72-90a001a1d33f_1.ogg',
    impactScore: 0.640489785136815,
  },
  {
    id: '2a576288-9398-4782-9875-7ae003679698',
    title: 'Edge of the Hex',
    rank: 133,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8d7c447b-4d4b-4770-ba76-741033d2ff07_0.ogg',
    impactScore: 0.6373216136161527,
  },
  {
    id: '0e7568e7-eea7-4d75-a998-bf2f943c6b35',
    title: 'Hexd Hearts',
    rank: 134,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_342b3d9a-42e4-4d98-b333-e9fde0cc959d_1.ogg',
    impactScore: 0.6364998247721383,
  },
  {
    id: '9f9df1c5-e51c-43e4-ba16-bb2173ab10c7',
    title: 'Pulse Collapse',
    rank: 135,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_590405c0-bc0c-4c03-b152-93d0676b74da_1.ogg',
    impactScore: 0.6354141331822938,
  },
  {
    id: '6a11d49c-1f1a-45fa-86d8-890574cd8d0c',
    title: 'Club Afterglow',
    rank: 136,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ce0227ee-52d2-4c29-b458-62661c537da5_1.ogg',
    impactScore: 0.6342575294576752,
  },
  {
    id: '690c4bdc-2918-45aa-8b2a-49960e94bca2',
    title: 'Six Flags of the Night',
    rank: 137,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9c8dc7d5-d36b-4723-b555-564815764bfa_0.ogg',
    impactScore: 0.6339457556831026,
  },
  {
    id: '47d7b370-c7b8-40c6-93da-3e675c924673',
    title: 'Club Static',
    rank: 138,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_63ea6c02-418e-40d4-bf9d-e27a28999229_0.ogg',
    impactScore: 0.6303689363748466,
  },
  {
    id: '1b47b92b-c95b-4ea1-8075-a43900f1b1a8',
    title: 'Club Static',
    rank: 139,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1b5eb688-7ad2-4857-a3db-7e9b29fd0754_1.ogg',
    impactScore: 0.6249292631430405,
  },
  {
    id: '4047be7f-4664-4aa9-b30e-cb9d852ce52b',
    title: 'Hexadecimal Afterglow',
    rank: 140,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_df400a14-9283-4d9c-821f-a823cb87fafc_1.ogg',
    impactScore: 0.6193705620775626,
  },
  {
    id: '5b61e733-ed88-413d-b598-7f70ade357b7',
    title: 'City Pulse Static',
    rank: 141,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc8dca5b-d61f-475c-ab83-e41975ac8f1d_0.ogg',
    impactScore: 0.6191065510209065,
  },
  {
    id: '07c6b310-1c4a-45e2-9700-f9e03b99db53',
    title: 'Hyperdrive Heartbeat',
    rank: 142,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e56db16a-6a4e-4017-b502-cc1b9cf28fc7_0.ogg',
    impactScore: 0.6136052725009015,
  },
  {
    id: '3af15afc-b3af-499d-9fde-1a25a2a215cc',
    title: 'Dash Through the Static',
    rank: 143,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_33e7d199-3813-4836-a17d-3675d6012bae_1.ogg',
    impactScore: 0.6126076483733479,
  },
  {
    id: 'fb859ae4-e62f-4e8c-b886-ab5fa353031d',
    title: 'Jersey Skyline Pulse',
    rank: 144,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a98931aa-fa6e-47ad-b9e5-4260f5918fe3_0.ogg',
    impactScore: 0.6118844009711569,
  },
  {
    id: 'b856ba76-c6f8-4157-b901-b9ac961bf98b',
    title: 'Fractured Frequencies',
    rank: 145,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_12656769-a445-4ce9-97d9-a0bcbb225075_1.ogg',
    impactScore: 0.6067600062731041,
  },
  {
    id: '3f803787-51d5-4e70-98fd-1b4c42d03a14',
    title: 'Hyperglide',
    rank: 146,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_57749849-a269-4077-b7b6-846d6011ec39_0.ogg',
    impactScore: 0.6061662523978151,
  },
  {
    id: '2faeee0f-c868-4720-b762-a36a50b4ead0',
    title: 'Vinyl Rush',
    rank: 147,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f62ecbdf-3cf0-436d-8803-237f4cc6bdd4_1.ogg',
    impactScore: 0.6040586947946935,
  },
  {
    id: 'bc75e40c-5c9b-46c3-8dab-d559d91ba6db',
    title: 'Club Circuit',
    rank: 148,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4dc770bd-e05a-443e-bdbf-07aeccb2d7dc_0.ogg',
    impactScore: 0.6018127824441694,
  },
  {
    id: '1fc011a9-b86e-40f8-a69d-4db33f6ff77f',
    title: 'Hyperdrive Hearts',
    rank: 149,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e2d24006-9502-42da-995b-ec198606dc5c_0.ogg',
    impactScore: 0.5998605762354384,
  },
  {
    id: '6fac9997-e88e-4b49-af64-04089c67f8c3',
    title: 'Hexed Frequency',
    rank: 150,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5a371964-bc3d-41ec-b4bc-23fde83f287f_0.ogg',
    impactScore: 0.5973232374109226,
  },
  {
    id: '9fb125fa-bf76-4d85-b457-e4a2afb0fe69',
    title: 'Glitch in the Skyline',
    rank: 151,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_69d5bb87-6545-4791-bc99-bcc0fc549eca_1.ogg',
    impactScore: 0.5870936945399315,
  },
  {
    id: '1c01acab-f32e-4c12-993c-4a38c6de1ba5',
    title: 'Night Shift Frequency',
    rank: 152,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bae5feb8-70f3-4350-bc97-a1144ed95c4f_1.ogg',
    impactScore: 0.585762209864509,
  },
  {
    id: '80f3ae70-10e0-4cd8-a422-8ac33a43ea40',
    title: 'Sixteen Hertz',
    rank: 153,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9b2c033d-ed77-4b36-a7b1-8a35bbd562d8_0.ogg',
    impactScore: 0.5844022439200404,
  },
  {
    id: 'a0c46127-166d-464c-b870-ea7a07489bc2',
    title: 'Velocity Bloom',
    rank: 154,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b07f0a21-48db-4e53-8bec-4442033d38da_0.ogg',
    impactScore: 0.5828730528483314,
  },
  {
    id: '6465a3a2-6fe5-40d2-ac43-0b0d750bc1ea',
    title: 'Transmission Overdrive',
    rank: 155,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9fe9c573-90ad-42b3-a499-d2ccb82c95b3_1.ogg',
    impactScore: 0.5806764813149694,
  },
  {
    id: '3d90f2fe-781d-491c-928a-a3f03c98d1d9',
    title: 'Hexed Horizon',
    rank: 156,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0b550f97-f806-456d-a3ad-579c71c28320_0.ogg',
    impactScore: 0.5789710166265569,
  },
  {
    id: 'cb77cb34-2ac8-43ac-81c4-9fa46b091c73',
    title: 'Pulse in Overdrive',
    rank: 157,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_01b43609-f0be-4795-bd5c-5452e53e8c05_1.ogg',
    impactScore: 0.5736841673081041,
  },
  {
    id: '032083e5-34ef-4d5f-b896-61137c709c32',
    title: 'Bassline Mirage',
    rank: 158,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fe8b0d15-0f61-495c-9b8e-ea8a028953d9_0.ogg',
    impactScore: 0.5724786130776599,
  },
  {
    id: '2c234ab5-54cc-45d2-bb39-cb0e7fc53748',
    title: 'Club Static',
    rank: 159,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c24d0266-8e1f-443d-916a-c52af236084c_1.ogg',
    impactScore: 0.5601940307986738,
  },
  {
    id: '998d2172-de59-47da-972f-4dd6ef786d40',
    title: 'Afterglow Static',
    rank: 160,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1180a711-affc-4591-893b-fc60eb59d1c1_0.ogg',
    impactScore: 0.5572818315306527,
  },
  {
    id: 'dcdc0e2a-fb13-4130-bd81-ac4180eeaf49',
    title: 'Berlin Static',
    rank: 161,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_55204fe3-565d-412f-b557-54fdb94ff587_1.ogg',
    impactScore: 0.5539377928604049,
  },
  {
    id: '9205b7f2-d9dd-44c7-851b-218013c119ae',
    title: 'Hexed Overdrive',
    rank: 162,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d37f07bf-8971-422d-adc4-3876d2511415_0.ogg',
    impactScore: 0.5513548098088931,
  },
  {
    id: '596986dd-9c6e-4bc9-abe6-1eb3e21fffbd',
    title: 'Hexed Pulse',
    rank: 163,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b8653a6d-fc77-48c7-a6c0-36b5384fb011_1.ogg',
    impactScore: 0.5488653817262577,
  },
  {
    id: '66931914-ba8c-4a53-a103-4645150d3cb2',
    title: 'Hexed Hearts',
    rank: 164,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ac5d598f-1737-410e-b53f-821f80a523b5_1.ogg',
    impactScore: 0.5479433011182343,
  },
  {
    id: '32d28041-6793-49ab-9f14-436208736243',
    title: 'Hexed in the Club',
    rank: 165,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_aa14cbaf-8ffe-4119-bfbb-98fb21ead171_0.ogg',
    impactScore: 0.5429788763153096,
  },
  {
    id: '541b2bd6-7ad3-4fbf-bff5-e644c9551eb1',
    title: 'Hexed Frenzy',
    rank: 166,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_590405c0-bc0c-4c03-b152-93d0676b74da_0.ogg',
    impactScore: 0.5405132303250543,
  },
  {
    id: '2cd642d0-da17-4ade-9c27-c7dce4669198',
    title: 'Sixteen Hertz Heaven',
    rank: 167,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ba6323f2-086e-4b22-a659-9373cf5b2c20_0.ogg',
    impactScore: 0.5395968700629317,
  },
  {
    id: 'c628685f-2f42-4a38-8f25-15fc67c5c5cd',
    title: 'Midnight Pulse',
    rank: 168,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_31a38d6c-7673-4ad9-ab07-2e10ec75a76c_0.ogg',
    impactScore: 0.5382085975754993,
  },
  {
    id: '69c8e46c-27f0-487c-9778-1d242bb54b2d',
    title: 'Club Hexagon',
    rank: 169,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8779d344-a7bd-4cde-9cc5-01b40e5dc1a5_1.ogg',
    impactScore: 0.5325631807012737,
  },
  {
    id: '3f1ceeb4-9c92-4f9e-9cb5-0b43d3121c69',
    title: 'City Pulse',
    rank: 170,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5d74a763-f7df-4d5e-8cf9-c058876686a1_0.ogg',
    impactScore: 0.5213351416268442,
  },
  {
    id: '447a44c1-8326-46d1-95f2-d30d19ab37f2',
    title: 'Sixth Gear Heartbeat',
    rank: 171,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_97b6dbd8-978d-4d48-860c-dc5c55048bd2_0.ogg',
    impactScore: 0.5195058996658171,
  },
  {
    id: '3af20d0d-e311-4f57-acf6-c8c2aa959bc8',
    title: 'Club Aurora',
    rank: 172,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_46e2818c-e5bf-4f96-8bf2-d56426a87bfd_1.ogg',
    impactScore: 0.5137672999359333,
  },
  {
    id: '9415109d-e322-4ae7-b872-c09de3fb3b5c',
    title: 'Berlin Afterdark',
    rank: 173,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_303f9660-22ef-4e97-a266-941a07d9fbf6_1.ogg',
    impactScore: 0.5122793873925879,
  },
  {
    id: 'c0a90488-dc55-48f9-abad-6b1a3dc12cbf',
    title: 'Hexcode Heartbeat',
    rank: 174,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b53d1127-186b-4d01-b727-70dd2449d2a2_0.ogg',
    impactScore: 0.510945600891221,
  },
  {
    id: '8d404de8-7f3e-4d49-b634-5ac257fad07d',
    title: 'Hexed Pulse',
    rank: 175,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc434117-7350-452a-bb25-b509a451d3c9_1.ogg',
    impactScore: 0.5076932499476952,
  },
  {
    id: '261dfbf2-33c8-4f62-8ce5-28b6da6c905d',
    title: 'Hexd Rhythms Run',
    rank: 176,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fe292c14-d02e-4a13-b350-b59b44c4a493_1.ogg',
    impactScore: 0.504582162406992,
  },
  {
    id: '0517dfc9-c2ee-4c2e-8323-6fee72169818',
    title: 'Berlin Lights',
    rank: 177,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8a99ed61-23ba-41c6-87a4-1ee67d5c8dc1_1.ogg',
    impactScore: 0.49873995615259853,
  },
  {
    id: 'd46e7ede-7a43-4d47-9d9e-afa3ec653605',
    title: 'Glitch & Glow',
    rank: 178,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3fe3d45d-ffb0-45da-bbfb-46249516e584_1.ogg',
    impactScore: 0.496600405452819,
  },
  {
    id: 'd2cbf2ba-743b-4d28-b4ae-de73bc5ed8b8',
    title: 'Club Overdrive',
    rank: 179,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b6e965b9-ecf1-4b14-ae8c-51859b45ccad_0.ogg',
    impactScore: 0.49312549140778017,
  },
  {
    id: '6c8053e9-8c21-4579-ba87-bdd9fa69ebfc',
    title: 'Hexd Horizon',
    rank: 180,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_63ea6c02-418e-40d4-bf9d-e27a28999229_1.ogg',
    impactScore: 0.4912677623262787,
  },
  {
    id: 'fc185dd6-59ad-4a5c-b563-d48731a5e6fc',
    title: 'Clubgrid Voltage',
    rank: 181,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bc0c7382-638c-4412-92d4-095dd805f153_0.ogg',
    impactScore: 0.4904306787352244,
  },
  {
    id: '76ad98aa-37b7-4a9f-baed-a5cd3f475ae1',
    title: 'Hyperdrive Hearts',
    rank: 182,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2d36610c-689c-43eb-8ecc-e59adfb7190b_0.ogg',
    impactScore: 0.48803697248215044,
  },
  {
    id: '169b905b-c771-4c94-be16-a428da12a8f9',
    title: 'Club Voltage Rush',
    rank: 183,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c667973d-709e-44f3-82df-164743f6f786_1.ogg',
    impactScore: 0.48785652232923804,
  },
  {
    id: '6d6620dc-be02-47c4-9b62-a57f1ea94b8d',
    title: 'Hexed in the Jersey Night',
    rank: 184,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d7a76ddf-ad85-4500-8f7c-6740c66fd1a4_0.ogg',
    impactScore: 0.4874534355408768,
  },
  {
    id: '3053e367-1526-475b-a9e1-1103e680df2f',
    title: 'Dash Through the Static',
    rank: 185,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b7035747-cbd2-4a8e-972e-078dc2772d1e_1.ogg',
    impactScore: 0.48480094017862485,
  },
  {
    id: '07ec62ba-227a-4dda-b4f1-ec5cef8ac764',
    title: 'Hexd Pulse',
    rank: 186,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_84eae012-df92-413d-9d04-840c4ba70157_1.ogg',
    impactScore: 0.4845974176573914,
  },
  {
    id: 'edfaefeb-3ef9-412f-a0d8-be79c9735070',
    title: 'Hexed Frequency',
    rank: 187,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_db2bc64d-b793-4d9e-81b5-7d170c9a2fb6_1.ogg',
    impactScore: 0.48113872215094605,
  },
  {
    id: '20258f54-3710-4ab7-8c72-20dc244d01a7',
    title: 'Jersey Nights',
    rank: 188,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b8653a6d-fc77-48c7-a6c0-36b5384fb011_0.ogg',
    impactScore: 0.47891770383185006,
  },
  {
    id: '15f1cdd4-58f8-40f4-801d-cef527644421',
    title: 'Six Degrees of Rush',
    rank: 189,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c8feeff0-92e8-4518-94f7-3eca9fd5bebe_1.ogg',
    impactScore: 0.4772446291666015,
  },
  {
    id: '64cb4ac0-ab02-4d5d-b088-2f459ce9902d',
    title: 'Hexed Horizons',
    rank: 190,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6eed580a-cc4b-4359-b9b4-5810cb513cf8_1.ogg',
    impactScore: 0.476889711296319,
  },
  {
    id: '0ed21c50-b053-40f1-b7be-d5eeea541aa5',
    title: 'Hexd in the Club',
    rank: 191,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8a99ed61-23ba-41c6-87a4-1ee67d5c8dc1_0.ogg',
    impactScore: 0.4757199520090857,
  },
  {
    id: 'f02a4d90-3288-44d4-9667-a594a58d1a7d',
    title: 'Pulse Points',
    rank: 192,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4a6f6bdc-8d3d-4b97-ba60-c6536ff21798_1.ogg',
    impactScore: 0.47288440199785897,
  },
  {
    id: '5ffe141b-8539-4c34-afc0-5ede75057bfe',
    title: 'Pulse of the Hex',
    rank: 193,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d3a002e8-7be9-4be4-b88a-99794972b789_0.ogg',
    impactScore: 0.4714259084625922,
  },
  {
    id: 'd571d02d-20c8-4f22-a665-176cf709a26b',
    title: 'Hyperglide Heartbeat',
    rank: 194,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5bd941ff-d7da-4db8-90ab-90967fe13d27_0.ogg',
    impactScore: 0.47069567801969375,
  },
  {
    id: '82505dda-cf1f-4e78-942d-c20d44daa294',
    title: 'Pulse of the Underground',
    rank: 195,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_881efd40-abff-459c-a2ef-5aa4764d939b_0.ogg',
    impactScore: 0.4549287677577821,
  },
  {
    id: '543decfc-b60b-45f2-91c6-473965f13642',
    title: 'Hexed Heartbeat',
    rank: 196,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d804852f-d313-4f16-96e0-00fd866b4282_0.ogg',
    impactScore: 0.4530970576880624,
  },
  {
    id: 'cd153247-f1a5-4e4a-b166-0a880ab4ae3c',
    title: 'Hexd Pulse',
    rank: 197,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8d03c6d0-5fe4-461b-8941-b2badcdeed13_1.ogg',
    impactScore: 0.44876802061638293,
  },
  {
    id: '78275cf9-85a9-4ace-9a36-421294716101',
    title: 'Jersey Afterglow',
    rank: 198,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_449677bb-6e0b-46d2-8d2e-b4b4752ba8f4_1.ogg',
    impactScore: 0.4449548774998937,
  },
  {
    id: '8078332d-87c3-4224-b638-b775d2a35b4e',
    title: 'Shattered Tempo',
    rank: 199,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e542a093-c1c0-410b-8582-1a5085c6ac06_1.ogg',
    impactScore: 0.44113394692777563,
  },
  {
    id: 'be897fcc-0d78-456a-bca7-cca249f1a9c8',
    title: 'Electric Rain',
    rank: 200,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ea798ac9-89b6-4408-a9a0-01cc3a9d9c35_1.ogg',
    impactScore: 0.43994636924828384,
  },
  {
    id: '261cd407-edc7-44c7-b9cf-b1b6b22c5ce6',
    title: 'Heartbeat Static',
    rank: 201,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9ef95a78-5b5e-47b1-9fa2-5dd136bff0be_0.ogg',
    impactScore: 0.4354757921704399,
  },
  {
    id: '70da2031-611c-434c-aab7-363ddc356cd7',
    title: 'Six-String Static',
    rank: 202,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_99e0b623-d3a9-4892-b34f-982f5bd312c9_0.ogg',
    impactScore: 0.43543252846722236,
  },
  {
    id: '8d06cc32-374e-43a8-919e-99644f1e7bfc',
    title: 'Glitchwave Alley',
    rank: 203,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f1e20b18-f164-42bd-bc72-9f730fbc4ef0_0.ogg',
    impactScore: 0.43542220363290596,
  },
  {
    id: 'f301f775-72f0-47a6-a3dd-8aaaa6f044e7',
    title: 'Club Velocity',
    rank: 204,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ba6323f2-086e-4b22-a659-9373cf5b2c20_1.ogg',
    impactScore: 0.4339881795168327,
  },
  {
    id: '3c62067c-5633-4199-81e4-ff207ef06cbb',
    title: 'Parallel Euphoria',
    rank: 205,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_01b43609-f0be-4795-bd5c-5452e53e8c05_0.ogg',
    impactScore: 0.43362050998213447,
  },
  {
    id: '9cfe30c7-0bab-4aea-9c2c-d4f7f8a3f8d0',
    title: 'Neon Circuit Breaker',
    rank: 206,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a3315550-df4d-49ad-9a98-8b89d609f5ea_0.ogg',
    impactScore: 0.43205840858244293,
  },
  {
    id: '0cb959c1-0521-47a9-9991-4561127643bc',
    title: 'Club Static',
    rank: 207,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d07ec41e-4f64-4aac-b277-89b8e6a85815_1.ogg',
    impactScore: 0.4306473463736341,
  },
  {
    id: '753ee20c-a9f3-4a0d-931b-0c0a76a949aa',
    title: 'Neon Jersey',
    rank: 208,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_33e7d199-3813-4836-a17d-3675d6012bae_0.ogg',
    impactScore: 0.430368631448152,
  },
  {
    id: 'acd7e254-d308-432c-9fa9-e2a7035104ab',
    title: 'Hexed Hearts',
    rank: 209,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1b5eb688-7ad2-4857-a3db-7e9b29fd0754_0.ogg',
    impactScore: 0.4298780640178711,
  },
  {
    id: '894d4ecd-4d69-4b26-9c9f-3cbf339405e9',
    title: 'Metro Static Rush',
    rank: 210,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fcda2eb7-3663-48df-8d3d-2070b4cfd84a_1.ogg',
    impactScore: 0.42967549040280695,
  },
  {
    id: '33182114-535b-4a9f-a35f-f5dd6f56feda',
    title: 'Six Feet of Static',
    rank: 211,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e64b0eba-5f0f-46c2-9726-e95c227e5067_0.ogg',
    impactScore: 0.42734626841724793,
  },
  {
    id: '44f4a9b8-ce5a-49e6-9c90-f04255f041f6',
    title: 'Club Without Limits',
    rank: 212,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_19e668f8-f8a2-4019-a7f3-efed38146fae_0.ogg',
    impactScore: 0.42514437877227473,
  },
  {
    id: 'edbbed25-a260-4a07-899c-1c6936237bc3',
    title: 'Afterglow Static',
    rank: 213,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e0de3353-4f8c-459c-977a-be59011dbc25_1.ogg',
    impactScore: 0.4225505781862109,
  },
  {
    id: 'a28c6ed0-6bb4-47d5-9963-b394a646eb3f',
    title: 'Rave Circuit',
    rank: 214,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6c80ad4b-4482-4716-804a-da0735a7ce1f_0.ogg',
    impactScore: 0.41481588920774365,
  },
  {
    id: 'ed339f9e-2541-4f96-a9ca-4adaa7876e8f',
    title: 'Club of Thunder',
    rank: 215,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b0e7e0de-2eaa-4a75-a938-7b98b32eb243_1.ogg',
    impactScore: 0.4122920036427735,
  },
  {
    id: 'dacb60ff-6630-470c-8211-9911ed402ae1',
    title: 'Sixteen Hexed Hearts',
    rank: 216,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_46e2818c-e5bf-4f96-8bf2-d56426a87bfd_0.ogg',
    impactScore: 0.4105696351495775,
  },
  {
    id: '6f3048ea-d9f3-4312-b534-a0a41fa00b68',
    title: 'Neon Pulse',
    rank: 217,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ee3d3037-ac27-417d-aeb3-9ea29a6a8791_0.ogg',
    impactScore: 0.40980046739778286,
  },
  {
    id: '53f531f9-761b-4c47-9282-93efee122305',
    title: 'Pulse of the Hex',
    rank: 218,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8dd360c0-2f6e-428b-a1f4-c9abf74fa08c_0.ogg',
    impactScore: 0.40725655723473797,
  },
  {
    id: 'dcb545d9-02ac-4744-a38c-fce6c3afe9a6',
    title: 'Hex Dancer',
    rank: 219,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b84472b0-724d-4c3a-836e-54e364f62bad_1.ogg',
    impactScore: 0.4051425655293091,
  },
  {
    id: 'e65bc9d7-e6ac-4be7-8018-3a1e3ef1931a',
    title: 'Hexd & Hypnotized',
    rank: 220,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_631793d6-8548-4247-b568-944215afc8ea_1.ogg',
    impactScore: 0.39439078626662705,
  },
  {
    id: '9d4e79bb-5818-47fd-a60d-35cafe3433ae',
    title: 'Shattered Trance Protocol',
    rank: 221,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_aa02806d-5e52-4712-a7b7-fd8c64f2c33c_1.ogg',
    impactScore: 0.3938910532855762,
  },
  {
    id: '7bd2c784-3551-489e-821c-6716a126a099',
    title: 'Jersey Rush',
    rank: 222,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ec857670-d303-4de5-8c20-b6b9ceadf595_0.ogg',
    impactScore: 0.3919431123240125,
  },
  {
    id: '587982e5-7af2-4f5b-98fa-e23e05a57de3',
    title: 'Skyline Static',
    rank: 223,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2ded7697-88d2-40be-af45-1c4dc7a1ad81_0.ogg',
    impactScore: 0.38933821015953957,
  },
  {
    id: 'e63a2497-2398-46bb-990b-d5810d3e0fca',
    title: 'Pixel Aurora',
    rank: 224,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5bd941ff-d7da-4db8-90ab-90967fe13d27_1.ogg',
    impactScore: 0.38884775063741306,
  },
  {
    id: '7bc0ef26-e135-4d03-bab8-9420a295486f',
    title: 'Hexed Voltage',
    rank: 225,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c8d0e686-9a9c-4c92-b64a-338979999636_1.ogg',
    impactScore: 0.3887409596168746,
  },
  {
    id: 'fd7e4bdb-e38d-43ad-bdf7-32410a557ea0',
    title: 'Hexed Frequency',
    rank: 226,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ff81bca5-cdcd-448c-85e7-a73be4658e09_0.ogg',
    impactScore: 0.3843678964453869,
  },
  {
    id: 'a33bce6e-9ad6-47c3-8816-74430ae60222',
    title: 'Club Gravity',
    rank: 227,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_25a0620a-8efb-4259-8c60-78cd07e42d2b_1.ogg',
    impactScore: 0.38336487909529715,
  },
  {
    id: '0b93f0b0-91cb-4de1-aabb-22301fa37ee1',
    title: 'Clubs & Static',
    rank: 228,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f62ecbdf-3cf0-436d-8803-237f4cc6bdd4_0.ogg',
    impactScore: 0.3829114894361026,
  },
  {
    id: 'fe812313-d1f5-437c-b2c3-06607bc21496',
    title: 'Amsterdam Afterglow',
    rank: 229,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bc0c7382-638c-4412-92d4-095dd805f153_1.ogg',
    impactScore: 0.38226182764256667,
  },
  {
    id: 'f0084e3c-d14e-4799-b15f-2339159cf528',
    title: 'Hexd Velocity',
    rank: 230,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e59d8158-8316-4ea8-9761-1649aecdf047_1.ogg',
    impactScore: 0.38195679443459174,
  },
  {
    id: '00f3fce5-2b31-404d-8eb9-e97be8b47822',
    title: 'Club Lucid',
    rank: 231,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_28634b30-c959-4fb4-b4b0-d0d5aaa8b79c_1.ogg',
    impactScore: 0.3814819712301745,
  },
  {
    id: '54453d0e-eddd-48fb-8cb5-0123b694aee7',
    title: 'Neon Rave Circuit',
    rank: 232,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_87231768-a88f-40ad-b4f1-defd81465905_0.ogg',
    impactScore: 0.3793886669430708,
  },
  {
    id: 'c243fa72-11bc-4770-9304-71d793c8136e',
    title: 'Midnight Momentum',
    rank: 233,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0867299b-8545-4cbf-a1fe-a29a36e959d6_0.ogg',
    impactScore: 0.37839111068677383,
  },
  {
    id: '100034da-7589-4f4d-867e-c4f2d317172e',
    title: 'Clubbed in the Haze',
    rank: 234,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fe292c14-d02e-4a13-b350-b59b44c4a493_0.ogg',
    impactScore: 0.37459656443926537,
  },
  {
    id: '8d2a590a-e803-4db8-a74e-673fbb9a757c',
    title: 'Hexed Velocity',
    rank: 235,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ce0227ee-52d2-4c29-b458-62661c537da5_0.ogg',
    impactScore: 0.37411847780242174,
  },
  {
    id: 'ce5428f2-4538-4913-a915-25f3bbe0704e',
    title: 'Hexd Dreams',
    rank: 236,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c1efd394-2fd3-4f16-ae62-727bc4b3d138_1.ogg',
    impactScore: 0.37098488738030816,
  },
  {
    id: '98407b6e-4707-4e17-b560-83ea6e08623a',
    title: 'Sixth Gear Heartbeat',
    rank: 237,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ccbc57fe-01f8-47fa-8a39-c8c68e7f1bab_1.ogg',
    impactScore: 0.37067988568267124,
  },
  {
    id: '51544b29-9e35-40b6-b0bf-50b8bc06ebbf',
    title: 'Rave in Sixteen',
    rank: 238,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_63cfe8f6-4f05-420a-91da-355c497ea921_1.ogg',
    impactScore: 0.36891750112096716,
  },
  {
    id: 'd0dfe93e-4046-433c-aa12-9924a9f073eb',
    title: 'Voltage Skyline',
    rank: 239,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a61cb7ef-e0f7-42f1-9a3a-697db3cdf030_1.ogg',
    impactScore: 0.3684379040961983,
  },
  {
    id: 'd007e9f3-966f-4ac0-a99b-1c8fe2d04aa7',
    title: 'Hyperdrive Reverie',
    rank: 240,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_60c8af4c-55ee-46c1-baac-1e7766751b14_1.ogg',
    impactScore: 0.36781440740110477,
  },
  {
    id: 'fad866e3-3d20-4b86-ac1e-93ed6a38a4df',
    title: 'Glitch in the Crowd',
    rank: 241,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_97b6dbd8-978d-4d48-860c-dc5c55048bd2_1.ogg',
    impactScore: 0.36653053700390426,
  },
  {
    id: '70d927d3-fac4-4dea-94f1-8d68f5c1d34f',
    title: 'Clubside Rush',
    rank: 242,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d37f07bf-8971-422d-adc4-3876d2511415_1.ogg',
    impactScore: 0.36465655054304624,
  },
  {
    id: '2865fca4-32fe-49f4-9296-95bc31346d37',
    title: 'Midnight Circuit',
    rank: 243,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_535e3c52-829b-4214-b43c-e29580e372f7_0.ogg',
    impactScore: 0.3643625703454947,
  },
  {
    id: 'c1ec2c41-21ce-409a-988f-856df95f54a9',
    title: 'Sixth Gear Hearts',
    rank: 244,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f22be085-b9b1-41e0-b940-ebb4f2ef5acb_0.ogg',
    impactScore: 0.3637508222246341,
  },
  {
    id: 'bbf90223-be07-47bc-add8-01a380b43213',
    title: 'Rave Frequency',
    rank: 245,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5cdd30ed-4eaa-457f-8d42-423cb1f00a31_1.ogg',
    impactScore: 0.3623230381790458,
  },
  {
    id: '20940c40-efc6-4747-9e36-fd67960a7070',
    title: 'Pulse of the Underground',
    rank: 246,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9ef95a78-5b5e-47b1-9fa2-5dd136bff0be_1.ogg',
    impactScore: 0.3622174798181892,
  },
  {
    id: '180dcff2-39a3-4b6a-8389-7d59f3c85089',
    title: 'Velvet Circuit',
    rank: 247,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_39cf476f-8c00-4604-8f6c-a82e807bc0cf_1.ogg',
    impactScore: 0.3603674030447418,
  },
  {
    id: 'd16a30ee-9387-4425-8afc-9ce9e1c4a99e',
    title: 'Club Hex',
    rank: 248,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_cb9e992d-1435-4801-8e24-bc07dd414e55_0.ogg',
    impactScore: 0.3590147868511811,
  },
  {
    id: '5b77ef9b-2f86-4211-9b78-4b79f64bf97b',
    title: 'Club Static',
    rank: 249,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e2d24006-9502-42da-995b-ec198606dc5c_1.ogg',
    impactScore: 0.3586173466047495,
  },
  {
    id: 'f041d16c-3ba2-4dee-b693-a98b3a979966',
    title: 'Outrun Static',
    rank: 250,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a61cb7ef-e0f7-42f1-9a3a-697db3cdf030_0.ogg',
    impactScore: 0.35602019252314904,
  },
  {
    id: 'da518592-6df6-4b6d-86e0-d73a239fad78',
    title: 'Club Static',
    rank: 251,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b6f739bc-6bce-4635-9235-dc29287f4b93_0.ogg',
    impactScore: 0.35516955769488856,
  },
  {
    id: '26f83a21-bdfb-4c8b-9d4b-25d621a75eec',
    title: 'Crimson Aperture',
    rank: 252,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f22be085-b9b1-41e0-b940-ebb4f2ef5acb_1.ogg',
    impactScore: 0.3544007888670267,
  },
  {
    id: 'e0724ac1-107e-44b1-b90e-bd519ac912d2',
    title: 'Hexd Velocity',
    rank: 253,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a9577f2c-05ea-4249-80d4-756aad1fb20d_0.ogg',
    impactScore: 0.35387451885980503,
  },
  {
    id: '3fabf4eb-ecd8-4aa1-80ad-efd8c92f4b1e',
    title: 'Ultra Velocity',
    rank: 254,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b6f739bc-6bce-4635-9235-dc29287f4b93_1.ogg',
    impactScore: 0.35306085814320015,
  },
  {
    id: '31bdf219-0c73-4758-aab0-a1ad20a9c3a6',
    title: 'Club Surge',
    rank: 255,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d804852f-d313-4f16-96e0-00fd866b4282_1.ogg',
    impactScore: 0.3502765510291195,
  },
  {
    id: '17731fbc-f24b-4a59-8049-cd8d6ca56996',
    title: 'Digital Rush',
    rank: 256,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_07c95038-705a-4e07-b201-43da225b2a50_1.ogg',
    impactScore: 0.3468683748977109,
  },
  {
    id: 'a877b6e5-c2bf-40b2-a104-3533436b799d',
    title: 'Gravity Rush',
    rank: 257,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e542a093-c1c0-410b-8582-1a5085c6ac06_0.ogg',
    impactScore: 0.34424064440497104,
  },
  {
    id: 'df4c28db-a6a5-4e2e-9547-4697a912c407',
    title: 'Pulse Overflow',
    rank: 258,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2c9c3d56-83f5-4766-a4e9-e0ad6ffadeda_0.ogg',
    impactScore: 0.3437261601863722,
  },
  {
    id: 'b4b3baa9-6b69-4851-86b9-6d43fe8e22dc',
    title: 'Hexed Pulse',
    rank: 259,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_aa02806d-5e52-4712-a7b7-fd8c64f2c33c_0.ogg',
    impactScore: 0.33590808678807677,
  },
  {
    id: 'e37ac62e-07e8-45a8-94cc-f1c3d945dd3a',
    title: 'Electric Decode',
    rank: 260,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5d74a763-f7df-4d5e-8cf9-c058876686a1_1.ogg',
    impactScore: 0.33531014638674256,
  },
  {
    id: '24737ebc-25dd-438b-95c0-3b3b5b6859f3',
    title: 'Bounce The Hex',
    rank: 261,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ea798ac9-89b6-4408-a9a0-01cc3a9d9c35_0.ogg',
    impactScore: 0.33283866120257144,
  },
  {
    id: 'cdc0f899-8d0f-4a0d-a141-2939b41d9efe',
    title: 'Sixth Gear Paradise',
    rank: 262,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_a3315550-df4d-49ad-9a98-8b89d609f5ea_1.ogg',
    impactScore: 0.32609192603529,
  },
  {
    id: '69cb822c-11e6-4985-a256-0245fa561c88',
    title: 'Velvet Static',
    rank: 263,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2b7434ed-ed9e-47d9-88f3-b2a412dfba69_1.ogg',
    impactScore: 0.3257584790449976,
  },
  {
    id: '7d5667d3-a68d-4af8-a376-5077056336cc',
    title: 'Club Anthem Overdrive',
    rank: 264,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_12656769-a445-4ce9-97d9-a0bcbb225075_0.ogg',
    impactScore: 0.32432909190369347,
  },
  {
    id: '2c792545-a947-4d60-bd9e-1d63fa1b91f2',
    title: 'Hexed Pulse',
    rank: 265,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6c80ad4b-4482-4716-804a-da0735a7ce1f_1.ogg',
    impactScore: 0.31565725935997085,
  },
  {
    id: '70a0fe68-5780-4e9a-8748-4780545820b5',
    title: 'Midnight Circuit',
    rank: 266,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_57d342f8-c8f4-4696-984f-442849c77f98_0.ogg',
    impactScore: 0.31563302344781824,
  },
  {
    id: '73659478-2f91-4a5d-9648-4204f45942d0',
    title: 'Berlin Syndrome',
    rank: 267,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_75d45218-63f9-46e9-8f4b-3be1b3ad14e3_1.ogg',
    impactScore: 0.3077267814054901,
  },
  {
    id: '26d5ac01-6e0d-4651-bbec-cd6d562b10fd',
    title: 'Velocity Overdrive',
    rank: 268,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b2029816-e240-4671-8f39-9ec97a4e40b5_1.ogg',
    impactScore: 0.30724844925192946,
  },
  {
    id: '928552bd-1433-4e0b-9b0f-6afee5dded18',
    title: 'Pulse in the Hexd',
    rank: 269,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_183109f3-48c5-4dcc-a7c9-b23db892bc3d_0.ogg',
    impactScore: 0.3055503225626721,
  },
  {
    id: '918c3124-8cc8-4ea8-acee-4adf4fe2d18b',
    title: 'Midnight Overdrive',
    rank: 270,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9abb7e00-eb86-4537-8800-32d574d80711_1.ogg',
    impactScore: 0.303978623137812,
  },
  {
    id: '0b7efe39-dc5f-47c2-b90f-2863b7a4fbe0',
    title: 'Six Hearts in a Jersey Club',
    rank: 271,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_df400a14-9283-4d9c-821f-a823cb87fafc_0.ogg',
    impactScore: 0.3024158299624273,
  },
  {
    id: '87d96d8f-f458-41c6-bcdd-7c13bcf9a574',
    title: 'Electric Afterglow',
    rank: 272,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5cdd30ed-4eaa-457f-8d42-423cb1f00a31_0.ogg',
    impactScore: 0.3022476661945645,
  },
  {
    id: '2cd0956f-3dd7-474d-adea-e9b7f6117c1d',
    title: 'Low Pass Havoc',
    rank: 273,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5e5e35b1-9c60-4786-9b02-c054577a0a1c_1.ogg',
    impactScore: 0.2973262060583319,
  },
  {
    id: 'a45e782b-c24b-40e6-87f9-d6649618ea67',
    title: 'Club Static Bloom',
    rank: 274,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_37a0348d-d7b1-4ee8-9894-75b90937d876_0.ogg',
    impactScore: 0.29665998596067045,
  },
  {
    id: 'fa178035-9fac-4d49-bb80-0110b030fdba',
    title: 'Hexed in the Night',
    rank: 275,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_ca63df49-2a05-4c55-9efa-d5ab95f1158f_0.ogg',
    impactScore: 0.2926720570647612,
  },
  {
    id: 'f9b574eb-0b77-431b-8cb6-cab58231439d',
    title: 'Hexed Velocity',
    rank: 276,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4dc770bd-e05a-443e-bdbf-07aeccb2d7dc_1.ogg',
    impactScore: 0.2896887605726284,
  },
  {
    id: '054aa704-0d2b-44e2-8799-0a936c8d6948',
    title: 'Electric Currents',
    rank: 277,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fe8b0d15-0f61-495c-9b8e-ea8a028953d9_1.ogg',
    impactScore: 0.28921668290491714,
  },
  {
    id: '025035b4-9abf-4166-aedc-8301386cd097',
    title: 'Club Zero Gravity',
    rank: 278,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c53f9dfe-cfd4-44ef-a6ef-c10468b55440_0.ogg',
    impactScore: 0.2879941103391219,
  },
  {
    id: '70fe6b9d-1a86-4d6d-80b7-1475c757f297',
    title: 'Club of Tomorrow',
    rank: 279,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_479418ea-4055-42a2-817a-a7dc8c1ca3a9_1.ogg',
    impactScore: 0.28742959301327636,
  },
  {
    id: '3a841113-0b63-4b29-8aeb-838ca2abf1fa',
    title: 'Fractured Pulse',
    rank: 280,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_e59d8158-8316-4ea8-9761-1649aecdf047_0.ogg',
    impactScore: 0.2858259509527322,
  },
  {
    id: '0a36afdf-99bd-4ce9-9f08-f63329ae4f56',
    title: 'Hexed Hearts',
    rank: 281,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9f7e8061-b7ea-4df3-9cdb-e15e420e8d58_1.ogg',
    impactScore: 0.28408657065792897,
  },
  {
    id: 'bdbd0bfa-7c9f-4f63-90d5-20c921e2a639',
    title: 'Glitch in the Heart',
    rank: 282,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_db331578-4165-4087-aa45-7a53b27521d8_0.ogg',
    impactScore: 0.28400577883962475,
  },
  {
    id: 'a5f978df-805b-44a6-8041-19324d34f15a',
    title: 'Velocity in the Dark',
    rank: 283,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9cc4817a-5466-4ce5-b788-348b6b3d4e68_1.ogg',
    impactScore: 0.28340530605587766,
  },
  {
    id: 'd79cfbc5-4d64-40c8-83f8-800d4c1f2006',
    title: 'Club Static',
    rank: 284,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0cf983a4-bda1-4a72-b004-fbad5c537f1f_0.ogg',
    impactScore: 0.2827743106774635,
  },
  {
    id: '413dbc4c-d490-4f45-9364-c1c7853cf811',
    title: 'Bounce in the Static',
    rank: 285,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b2029816-e240-4671-8f39-9ec97a4e40b5_0.ogg',
    impactScore: 0.2813676764201808,
  },
  {
    id: '904c41cb-c662-4a6a-8178-bc0d7a3c2b15',
    title: 'Hexed Pulse',
    rank: 286,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4e04baed-c322-48ae-8251-7c20136014a6_0.ogg',
    impactScore: 0.2786757811562479,
  },
  {
    id: 'fdda0815-149d-4c75-afce-0997cfa148e7',
    title: 'Velocity Shatter',
    rank: 287,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_25a0620a-8efb-4259-8c60-78cd07e42d2b_0.ogg',
    impactScore: 0.2776454176040953,
  },
  {
    id: '48a32faa-e50c-4965-ae03-a62d5c55ee83',
    title: 'Static Rush',
    rank: 288,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_94d4d1a1-f95d-47d6-841f-9c342f743ed4_1.ogg',
    impactScore: 0.27710316075544367,
  },
  {
    id: 'c3d8c88c-f4fd-4b2d-8465-95bfbcd2766a',
    title: 'Hex Code High',
    rank: 289,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d5d8b462-1bf3-41bf-8372-f758f9a67b9b_0.ogg',
    impactScore: 0.27602900415944304,
  },
  {
    id: '81e4efc6-98ef-45a1-8d20-fe319fbaaf59',
    title: 'Velvet Overdrive',
    rank: 290,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3fe3d45d-ffb0-45da-bbfb-46249516e584_0.ogg',
    impactScore: 0.27583021260029394,
  },
  {
    id: '921dc1e6-600e-4d40-946c-01c40d444bb5',
    title: 'Jersey Afterglow',
    rank: 291,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_07c95038-705a-4e07-b201-43da225b2a50_0.ogg',
    impactScore: 0.2752475494433933,
  },
  {
    id: '51dc3b8c-3b47-4c97-8ca9-584f5e1675d4',
    title: 'Pulse Velocity',
    rank: 292,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9095b8bf-83dc-4a37-a7d5-717b8270ad11_1.ogg',
    impactScore: 0.26700427798658777,
  },
  {
    id: '83c656c0-259c-4a7c-bd85-ae8abd139648',
    title: 'Shattered Synths',
    rank: 293,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_300119a4-2a4f-425d-a5b8-78e7e78020b2_1.ogg',
    impactScore: 0.266101077198414,
  },
  {
    id: '4e75a571-1809-4f12-9c40-314f1340551f',
    title: 'Velocity Dream',
    rank: 294,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_8779d344-a7bd-4cde-9cc5-01b40e5dc1a5_0.ogg',
    impactScore: 0.26469756996042776,
  },
  {
    id: '17ad8eaf-8dcc-4d24-9233-339c3450a40a',
    title: 'Digital Rush',
    rank: 295,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2c9c3d56-83f5-4766-a4e9-e0ad6ffadeda_1.ogg',
    impactScore: 0.26360344573254924,
  },
  {
    id: 'b2ab5c90-c719-4f58-961e-2352b0594f25',
    title: 'Hexed Velocity',
    rank: 296,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b0e7e0de-2eaa-4a75-a938-7b98b32eb243_0.ogg',
    impactScore: 0.26277483868250334,
  },
  {
    id: 'c538fa1b-87d9-4fb3-9151-722e3e32bf2d',
    title: 'Hyperdrive Hearts',
    rank: 297,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_995b799f-02fe-4a87-b9b4-749ed29d4222_0.ogg',
    impactScore: 0.2586659597857205,
  },
  {
    id: 'fc34037c-0a80-49b0-bf09-0f81a5c9ccad',
    title: 'Strobe Light Motion',
    rank: 298,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3e605cfd-714e-4b58-9694-90db75876096_1.ogg',
    impactScore: 0.2583722724165303,
  },
  {
    id: 'f27da86d-cd4d-44a9-b8f2-5d318a7fbec4',
    title: 'Club Euphoria',
    rank: 299,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0575a9d2-b69e-41f5-96f4-0d47c597432e_1.ogg',
    impactScore: 0.2583580991640771,
  },
  {
    id: 'b9e9ac6d-b1ca-4a37-996e-44d46cb91a5a',
    title: 'Glass Heartbeat',
    rank: 300,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5f04ca0c-a867-4941-84ca-4916246dd43b_0.ogg',
    impactScore: 0.257792392572799,
  },
  {
    id: 'cbf20225-512d-4e05-b106-56a355182f26',
    title: 'Hex Drive Pulse',
    rank: 301,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_37a0348d-d7b1-4ee8-9894-75b90937d876_1.ogg',
    impactScore: 0.2543407695648533,
  },
  {
    id: '46550e8a-6125-448d-8fde-f126213e81f1',
    title: 'Midnight Circuit',
    rank: 302,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d3a002e8-7be9-4be4-b88a-99794972b789_1.ogg',
    impactScore: 0.2541864214300885,
  },
  {
    id: '8f26e63d-061b-4ad0-a98a-5ed432d33308',
    title: 'Midnight Voltage',
    rank: 303,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_678e5df5-f197-4f14-92a7-bca755543734_0.ogg',
    impactScore: 0.2540889598707021,
  },
  {
    id: '148ef1cb-d1d7-4976-824d-77cb3e7a7bcc',
    title: 'Hexd Horizon',
    rank: 304,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_acaf458b-7595-406f-9c8f-e313b6fe7547_0.ogg',
    impactScore: 0.2529112618891308,
  },
  {
    id: '18e5aeb1-93d0-4ca8-8314-6e1963cdafde',
    title: 'Clubside Anthem',
    rank: 305,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7a63f79c-8ce0-4597-9d83-b67568b80a03_0.ogg',
    impactScore: 0.2527519587936461,
  },
  {
    id: 'f979da24-52f8-4211-a9f3-ec094b287b05',
    title: 'Pulse Circuit',
    rank: 306,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_444fb966-be3e-489a-aee7-81c3250f6fcf_1.ogg',
    impactScore: 0.25266161624366873,
  },
  {
    id: '43e10453-fb00-4245-ac00-814de737f1ac',
    title: 'Hexed Velocity',
    rank: 307,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0575a9d2-b69e-41f5-96f4-0d47c597432e_0.ogg',
    impactScore: 0.25122039626777004,
  },
  {
    id: 'c5e147eb-7b87-4f17-9196-e138731aa720',
    title: 'Hexed Heartbeat',
    rank: 308,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_28634b30-c959-4fb4-b4b0-d0d5aaa8b79c_0.ogg',
    impactScore: 0.2511708456814983,
  },
  {
    id: '468b164a-f417-462c-939d-148b3d5dc623',
    title: 'Pulse in the Static',
    rank: 309,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_437c15d8-bf76-4af4-a914-7788c04e8cc9_1.ogg',
    impactScore: 0.2498160842715226,
  },
  {
    id: '87a76250-2673-4498-982c-4c3b6649488e',
    title: 'Club Ghost Signal',
    rank: 310,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_2ded7697-88d2-40be-af45-1c4dc7a1ad81_1.ogg',
    impactScore: 0.24253444575318028,
  },
  {
    id: 'e1653c3b-056e-4dfc-a885-eb89ebbdb876',
    title: 'Club Static Pulse',
    rank: 311,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1da4f764-8ef1-4427-ac3a-f111b7d6591b_1.ogg',
    impactScore: 0.24066423638583329,
  },
  {
    id: '73b7d5d4-38f3-4224-accf-1ea89153e4c7',
    title: 'Jersey Static',
    rank: 312,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_479418ea-4055-42a2-817a-a7dc8c1ca3a9_0.ogg',
    impactScore: 0.24012789938995563,
  },
  {
    id: '4c073ff1-94dc-4ad9-befe-166a45449f0b',
    title: 'Shooting Stars in Jersey',
    rank: 313,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_db2bc64d-b793-4d9e-81b5-7d170c9a2fb6_0.ogg',
    impactScore: 0.2395844796440298,
  },
  {
    id: '46c3d3b1-221c-4335-a9e2-ef82d7108104',
    title: 'Hexed Voltage',
    rank: 314,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_6236decc-fb9b-4dd5-a4aa-35a1b23c44e7_1.ogg',
    impactScore: 0.23680471171424672,
  },
  {
    id: '95924735-73d3-4197-8a21-87bf7b7c3a31',
    title: 'Hex Dreams',
    rank: 315,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_77816e27-7c06-49bf-8c84-6d1f2d80a7a9_0.ogg',
    impactScore: 0.23666880118715436,
  },
  {
    id: '0add41e0-a79e-49a1-b453-d059d9c90562',
    title: 'Static Hearts',
    rank: 316,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_535e3c52-829b-4214-b43c-e29580e372f7_1.ogg',
    impactScore: 0.23164468761179327,
  },
  {
    id: 'e1e85f6d-c7d2-4bd5-8150-184c7ab7bf96',
    title: 'Hexd Pulse',
    rank: 317,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_da47eb42-0d39-4476-adb9-8a3ae583ae23_1.ogg',
    impactScore: 0.23110289550539942,
  },
  {
    id: '7b02ffb5-5ab4-48fd-9be2-af896ba9ea7c',
    title: 'Berlin Hex Pulse',
    rank: 318,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_87231768-a88f-40ad-b4f1-defd81465905_1.ogg',
    impactScore: 0.23053805032134186,
  },
  {
    id: 'd6e0db94-d821-4353-8329-561308d05ef2',
    title: 'Glitch in the Afterglow',
    rank: 319,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7cce1908-0457-4495-bf44-6e43d047a2ab_0.ogg',
    impactScore: 0.230239827515425,
  },
  {
    id: 'a01da0f8-3d13-434c-b89f-3a4d29083822',
    title: 'Neon Circuit Breaker',
    rank: 320,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_4a6f6bdc-8d3d-4b97-ba60-c6536ff21798_0.ogg',
    impactScore: 0.22919651826352283,
  },
  {
    id: '8f9bbed4-44bb-4520-92c1-cb9f4c14c67c',
    title: 'Neon Jersey',
    rank: 321,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0ec81db5-df9b-43d6-b60d-008905e32af8_0.ogg',
    impactScore: 0.22699030704410814,
  },
  {
    id: 'b263ffb4-5052-4f8d-8e4c-5a3c134207cf',
    title: 'Clubbed in Neon',
    rank: 322,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c8d0e686-9a9c-4c92-b64a-338979999636_0.ogg',
    impactScore: 0.22330670269021008,
  },
  {
    id: '307b070a-004f-4d73-9031-2aa3ce7a96ea',
    title: 'Club Static',
    rank: 323,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fc434117-7350-452a-bb25-b509a451d3c9_0.ogg',
    impactScore: 0.2221065150545633,
  },
  {
    id: '06706703-9b1d-4bff-b8b3-1e978bbc42f1',
    title: 'Club Frequency',
    rank: 324,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_da47eb42-0d39-4476-adb9-8a3ae583ae23_0.ogg',
    impactScore: 0.22153186238256298,
  },
  {
    id: 'fec8d33d-cf8c-4368-9eba-00eb7a4e872c',
    title: 'Club of Broken Light',
    rank: 325,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_437c15d8-bf76-4af4-a914-7788c04e8cc9_0.ogg',
    impactScore: 0.22047963600344925,
  },
  {
    id: '8cd1d8f3-2ae3-43b4-82a9-f0b442e6b6c7',
    title: 'Midnight Circuit Breaker',
    rank: 326,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f4900a5b-a69e-4102-9444-8a9b1f4b391a_0.ogg',
    impactScore: 0.21899823451922304,
  },
  {
    id: 'f262126f-64a5-4f49-8508-24971f065daa',
    title: 'Velocity Dreams',
    rank: 327,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3f22993d-b7af-433b-8479-228d8b2736d0_1.ogg',
    impactScore: 0.21358099084131457,
  },
  {
    id: '2e0be86e-1146-4e2a-a68d-2632c229aaef',
    title: 'Pulse Runner',
    rank: 328,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_39cf476f-8c00-4604-8f6c-a82e807bc0cf_0.ogg',
    impactScore: 0.21152125510850178,
  },
  {
    id: '9cb5a092-11ff-4e7c-a976-e3934aa31fab',
    title: 'Jersey Skyline Pulse',
    rank: 329,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f5d8e8e5-4d00-44c7-8685-3a01659184b7_1.ogg',
    impactScore: 0.2077248342610286,
  },
  {
    id: 'bcbb094a-76dd-40db-96e0-0dad7b0738fe',
    title: 'Glitch in the Static',
    rank: 330,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d47d912f-677c-42d8-b166-fe076020de2e_0.ogg',
    impactScore: 0.20381064910637234,
  },
  {
    id: '210f012e-08c5-47bc-9c28-7c51e515c9ef',
    title: 'Trance In The Streets',
    rank: 331,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0b550f97-f806-456d-a3ad-579c71c28320_1.ogg',
    impactScore: 0.20316140519898276,
  },
  {
    id: '7f7c8c0e-78ce-48a7-86aa-f42a73721ce8',
    title: 'Electric Maze',
    rank: 332,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_db331578-4165-4087-aa45-7a53b27521d8_1.ogg',
    impactScore: 0.20272642641895852,
  },
  {
    id: '510148cb-3fbb-45ae-9b45-edcdcfb90218',
    title: 'Hexed Velocity',
    rank: 333,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_66ebbf5e-0ac7-4cd2-843e-4302f52234ad_1.ogg',
    impactScore: 0.20013182639823987,
  },
  {
    id: '686a8867-339b-4218-b8cd-cea1a8b2329e',
    title: 'Club Heartbeat',
    rank: 334,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9f9808fc-a6db-447e-a81b-cd8f03c867ee_0.ogg',
    impactScore: 0.1991963571911256,
  },
  {
    id: '50ede3a4-e705-4ab8-8762-aa757c58a81c',
    title: 'Velocity Dreams',
    rank: 335,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_bae5feb8-70f3-4350-bc97-a1144ed95c4f_0.ogg',
    impactScore: 0.19188690669881595,
  },
  {
    id: '48251897-abfd-41f7-9d02-d42879f940e1',
    title: 'Velvet Circuit',
    rank: 336,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9f7e8061-b7ea-4df3-9cdb-e15e420e8d58_0.ogg',
    impactScore: 0.19010591664083404,
  },
  {
    id: 'ddf29bb7-fe0d-4e4b-aaf8-b2c95e73654c',
    title: 'Clubside Rush',
    rank: 337,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c27f91a9-127f-4629-8d43-1999598416f7_0.ogg',
    impactScore: 0.18783416862101213,
  },
  {
    id: '90414de8-e15a-433c-b4fb-491f53710634',
    title: 'Static Rush',
    rank: 338,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_0867299b-8545-4cbf-a1fe-a29a36e959d6_1.ogg',
    impactScore: 0.1856560374470943,
  },
  {
    id: '3c37d771-43d2-45f6-b698-537edbfb605b',
    title: 'Velocity Hearts',
    rank: 339,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1180a711-affc-4591-893b-fc60eb59d1c1_1.ogg',
    impactScore: 0.18223223358411217,
  },
  {
    id: '4f32f806-1e7e-4ef1-a1ac-ad490d4bcf5b',
    title: 'Glitch in the Tempo',
    rank: 340,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_b085a140-1285-4113-90db-f2dd069094aa_1.ogg',
    impactScore: 0.18128868491534167,
  },
  {
    id: '5f28b35d-f0d4-4e71-aa09-787d73855a8e',
    title: 'ClubTech Ascent',
    rank: 341,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_03c1608c-f316-4bd2-b66a-b63694583570_1.ogg',
    impactScore: 0.1759116309741815,
  },
  {
    id: '77e36beb-4354-4a51-aa5f-7c130b4d18da',
    title: 'Hexagonal Pulse',
    rank: 342,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_35e6bc66-df2e-468b-b274-167dd5ce570c_0.ogg',
    impactScore: 0.17477276680930368,
  },
  {
    id: '4cdcce87-e001-46cd-bc53-07c2f0d8cf69',
    title: 'Jersey Pulse',
    rank: 343,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c1efd394-2fd3-4f16-ae62-727bc4b3d138_0.ogg',
    impactScore: 0.17260798848899062,
  },
  {
    id: '68ad997e-ee8d-4a2a-8844-c71ae72e682d',
    title: 'Ride The Static',
    rank: 344,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_303f9660-22ef-4e97-a266-941a07d9fbf6_0.ogg',
    impactScore: 0.1721710520038956,
  },
  {
    id: '49edc4fd-8d19-454d-913b-b5513e9856b3',
    title: 'Velocity Dreams',
    rank: 345,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_1da4f764-8ef1-4427-ac3a-f111b7d6591b_0.ogg',
    impactScore: 0.17067187535021552,
  },
  {
    id: 'b3870112-42ee-4697-ad5d-52629b70f9c3',
    title: 'Pulse Overdrive',
    rank: 346,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7a63f79c-8ce0-4597-9d83-b67568b80a03_1.ogg',
    impactScore: 0.16929687276501373,
  },
  {
    id: 'a872e1f1-1f4d-4dfa-b127-6bdc5ee03d63',
    title: 'Velocity Hearts',
    rank: 347,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_d4ddb84b-76f6-48fb-bcbb-9b0e6171fcd5_0.ogg',
    impactScore: 0.16659085461672402,
  },
  {
    id: '961e99cd-da7d-4bc3-b67d-720e8cca6b1d',
    title: 'Midnight Overdrive',
    rank: 348,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_cfc589ab-3898-4a58-8faa-0a83d831afb9_1.ogg',
    impactScore: 0.16598038293507797,
  },
  {
    id: '25ab527b-6cdd-473b-b2c4-4ebe35167478',
    title: 'Static Skyline',
    rank: 349,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_3c990615-6cc5-453f-aeb4-8a64b2be3c2c_1.ogg',
    impactScore: 0.16555912408876403,
  },
  {
    id: '8bdcbe13-eba3-4ebb-9dc9-0c2f64aaef62',
    title: 'Heartbeat Static',
    rank: 350,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_9abb7e00-eb86-4537-8800-32d574d80711_0.ogg',
    impactScore: 0.16541549780950113,
  },
  {
    id: '1e8a690d-276b-4562-9d1e-e6359e8e3e77',
    title: 'Crash Landing on the Grid',
    rank: 351,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f4ba621b-ab37-4290-85a1-97b979663b0d_1.ogg',
    impactScore: 0.16495944799361487,
  },
  {
    id: 'ce21a763-67d0-4ff4-979c-a8accba35527',
    title: 'Hexed Velocity',
    rank: 352,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_fcda2eb7-3663-48df-8d3d-2070b4cfd84a_0.ogg',
    impactScore: 0.14643678307309088,
  },
  {
    id: 'a2422fd2-f109-45ab-88e1-19865ae21213',
    title: 'Velocity Hearts',
    rank: 353,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_28c3d6e3-328d-45c3-8cba-43525a4f8fca_0.ogg',
    impactScore: 0.14381639983100247,
  },
  {
    id: '488272d2-565d-42f5-a09a-ca8514df5df9',
    title: 'Neon Bounce',
    rank: 354,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_cf196220-0f42-48d5-a616-ed94081901a6_1.ogg',
    impactScore: 0.14285451260817908,
  },
  {
    id: 'fee80aea-a9aa-4edd-9da0-745b5b0ab4c9',
    title: 'Strobe Light Vultures',
    rank: 355,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_5f6cb465-e530-4a92-a9d8-23d68417db49_0.ogg',
    impactScore: 0.13622234494341795,
  },
  {
    id: '1aa3cdb5-3012-483a-9562-6999e034c26e',
    title: 'Hexlock Groove',
    rank: 356,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_03c1608c-f316-4bd2-b66a-b63694583570_0.ogg',
    impactScore: 0.13576266775687243,
  },
  {
    id: '32984546-1550-46d9-9eec-a28be915d042',
    title: 'Trance Velocity',
    rank: 357,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_77ecfff0-a312-4c32-be9c-87dec642111d_1.ogg',
    impactScore: 0.127491998908503,
  },
  {
    id: '210fa196-7087-4cfc-be5e-8199ce8134de',
    title: 'Shimmer & Shatter',
    rank: 358,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_7c7bfeeb-3a36-44c5-a1a4-3dc7dc4c905d_0.ogg',
    impactScore: 0.11593469411037749,
  },
  {
    id: 'b2dd3762-363e-4b3b-ba98-c886b6fc89aa',
    title: 'Club Acid Rush',
    rank: 359,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_f557bd12-06c0-4911-af12-1db080580b68_1.ogg',
    impactScore: 0.11018158480799649,
  },
  {
    id: '173930c1-6b53-4b59-9c4e-ac3b4c093c67',
    title: 'Clubside Dreams',
    rank: 360,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_35e6bc66-df2e-468b-b274-167dd5ce570c_1.ogg',
    impactScore: 0.09219959527357063,
  },
  {
    id: '581cdec8-54e6-420e-9359-bc257cdd422b',
    title: 'Club Static',
    rank: 361,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_66ebbf5e-0ac7-4cd2-843e-4302f52234ad_0.ogg',
    impactScore: 0.054464487508125194,
  },
  {
    id: '28ebf704-032c-4207-9bdc-f9d5d75b1b79',
    title: 'Jersey Static',
    rank: 362,
    audioUrl:
      'https://cdn.treblo.com/generations3/audio_c8feeff0-92e8-4518-94f7-3eca9fd5bebe_0.ogg',
    impactScore: 0.026354207848275944,
  },
];
